<template>
  <span class="radiobox" :class="{ checked: value }" @click="$emit('input', !value)" />
</template>

<script>
export default {
  props: ['value'],
}
</script>

<style lang="scss" scoped>
.radiobox {
  display: flex;
  justify-content: center;
  align-items: center;

  height: 18px;
  width: 18px;
  border: 1px solid #5e5e5e;
  border-radius: 100%;
  background-color: #ffffff;
  box-shadow: 0 0 1px 1px rgba(22, 23, 26, 0.08), 0 1px 4px 0 rgba(22, 23, 26, 0.2);
  cursor: pointer;

  &.checked {
    &:after {
      content: '';
      height: 10px;
      width: 10px;
      background-color: #5e5e5e;
      border-radius: 100%;
    }
  }
}
</style>